import { combineReducers } from 'redux';
import AuthReducer from './AuthReducer';
import AdminReducer from './AdminReducer';
import QuoteReducer from './QuoteReducer';

export default combineReducers({
    auth: AuthReducer,
    admin: AdminReducer,
    quotes: QuoteReducer
});
